// src/components/Footer/Footer.js
import React from 'react';
import styles from './Footer.module.css';

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerInner}>
        <p className={styles.brand}>Castle Point Innovations &mdash; Cuitt LLC</p>
        <p className={styles.contact}>
          <a href="mailto:contact@castlepointinnovations.com">
            contact@castlepointinnovations.com
          </a>
        </p>
        <p className={styles.copy}>
          &copy; {new Date().getFullYear()} All rights reserved.
        </p>
      </div>
    </footer>
  );
}

export default Footer;
